import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { addDays } from 'date-fns';
import { isMobileOnly } from 'react-device-detect';
import PropTypes from 'prop-types';
import { renderComponentField } from '@/shared/components/form/FormField';
import { Col } from 'reactstrap';

const IntervalDatePicker = ({
                          maxDayRange, shouldCloseOnSelect,
                          startDate, endDate, disabled,
                          setStartDate, setEndDate, setDisabled,
}) => {
  const handleChangeStart = (date) => {
    setStartDate(date);
    setEndDate(date);
    setDisabled(false);
  };

  const handleChangeEnd = (date) => {
    setEndDate(date);
  };

  return (
    <div className="date-picker date-picker--interval">
      <Col>
        {
          maxDayRange > 1
          ? <span>Start Date</span>
          : <span>Date</span>
        }
        <DatePicker
          selected={startDate}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          maxDate={new Date()}
          onChange={handleChangeStart}
          dateFormat="yyyy/MM/dd"
          placeholderText="From"
          dropDownMode="select"
          withPortal={isMobileOnly}
          shouldCloseOnSelect={shouldCloseOnSelect}
        />
      </Col>
      {
        maxDayRange > 1
          ? (
            <Col>
              <span>End Date</span>
              <DatePicker
                disabled={disabled}
                selected={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                maxDate={addDays(startDate, maxDayRange)}
                minDate={startDate}
                onChange={handleChangeEnd}
                dateFormat="yyyy/MM/dd"
                placeholderText="To"
                dropDownMode="select"
                withPortal={isMobileOnly}
                shouldCloseOnSelect={shouldCloseOnSelect}
              />
            </Col>
            )
          : null
      }
    </div>
  );
};

IntervalDatePicker.defaultProps = {
  maxDayRange: 1,
};

IntervalDatePicker.propTypes = {
  shouldCloseOnSelect: PropTypes.bool.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  disabled: PropTypes.bool.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setDisabled: PropTypes.func.isRequired,
  maxDayRange: (props, propName, componentName) => {
    const value = props[propName];
    if (typeof value === 'number' && value >= 1 && value % 1 === 0) {
      return null;
    }
    return new Error(
      `Invalid prop ${propName} supplied to ${componentName}.
       ${propName} needs to be a positive integer.`,
    );
  },
};

export default renderComponentField(IntervalDatePicker);
